// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__94IaH","image":"Avatar_image__Mkkwm","photo":"Avatar_photo__+IkHm","active":"Avatar_active__DWUe6","notification":"Avatar_notification__Z9jfc"};